import React from "react";
import { SingleSharers } from  '../pages/single';
export default class Footer extends React.Component{
  render(){
    var p = {
      title: '#JusticiaCotidiana: Ciudadanos indefensos en el día a día'
    }
    return(
      <div id="footer">
        <div id="footer_content">
          <a href="https://animalpolitico.com" target="_blank">
            <img src={require('../static/apw.png')}  id="apfooter"/>
          </a>
          <div id="footer_sharers">
            <SingleSharers p={p}/>
          </div>
          <div id="footer_wjp">
            En colaboración con <a href="https://worldjusticeproject.mx/" target="_blank"><img src={require('../static/wjp.png')} /></a>
          </div>
          <div id="footer_date">
            Publicado el <strong>24 de noviembre del 2019</strong>
          </div>
        </div>
      </div>
    )
  }
}
